import axios from "@/axios";
import Vue from "vue";

const state = {
  goals: []
};

const actions = {
  fetchGoals({ commit }, config) {
    return axios.get('goals', config)
      .then((r) => {
        if (r.data.success) {
          commit('SAVE_GOALS', r.data.goals)
        } else {
          throw new Error("Goals forbidden");
        }
      })
  }
};

const mutations = {
  SAVE_GOALS(state, goals) {
    Vue.set(state, 'goals', goals);
  }
};

export default {
  state, actions, mutations
}
